import React, { ReactElement } from 'react';
import Icon from '@amzn/awsui-components-react/polaris/icon';
import { Button, Grid, SpaceBetween, Spinner, TextContent } from '@amzn/awsui-components-react-v3';
import { Part } from './types';

export const LOADING_COLUMN = {
  id: 'loading',
  header: 'Status',
  // eslint-disable-next-line consistent-return
  cell: (item: Part): ReactElement => {
    switch (item.response) {
      case 'success':
        return (
          <Grid gridDefinition={[{ colspan: 1 }, { colspan: 8 }]}>
            <Icon name="status-positive" variant="success" />
            <TextContent>Moved</TextContent>
          </Grid>
        );
      case 'warning':
        return (
          <Grid gridDefinition={[{ colspan: 1 }, { colspan: 8 }]}>
            <Icon name="status-warning" variant="warning" />
            <TextContent>See actions</TextContent>
          </Grid>
        );
      case 'error':
        return (
          <Grid gridDefinition={[{ colspan: 1 }, { colspan: 8 }]}>
            <Icon name="status-negative" variant="error" />
            <TextContent>See actions</TextContent>
          </Grid>
        );
      case 'loading':
        return (
          <Grid gridDefinition={[{ colspan: 1 }, { colspan: 8 }]}>
            <Spinner />
            <TextContent>Processing</TextContent>
          </Grid>
        );
      case 'reverted':
        return (
          <Grid gridDefinition={[{ colspan: 1 }, { colspan: 8 }]}>
            <Icon name="undo" />
            <TextContent>Reverted</TextContent>
          </Grid>
        );
      case 'pending_bulk_move':
        return (
          <Grid gridDefinition={[{ colspan: 1 }, { colspan: 8 }]}>
            <Icon name="status-in-progress" />
            <TextContent>Pending confirmation</TextContent>
          </Grid>
        );
      default:
        return (
          <Grid gridDefinition={[{ colspan: 1 }, { colspan: 8 }]}>
            <Icon name="status-stopped" />
            <TextContent>Unknown</TextContent>
          </Grid>
        );
    }
  },
};

export const SERIAL_COLUMN = {
  id: 'serial_id',
  header: 'Serial ID',
  cell: (item: Part): string => item.serialId,
  sortingField: 'id',
};

export const LOCATION_COLUMN = {
  id: 'location',
  header: 'Location',
  cell: (item: Part): string => item.location,
  sortingField: 'location',
};

export const ACTION_REQUIRED_COLUMN = {
  id: 'action',
  header: 'Action required',
  cell: (item: Part): ReactElement => {
    if (item.response === 'warning') {
      return (
        <SpaceBetween size="s" direction="horizontal">
          <div style={{ padding: '6px 0px 0px 0px' }}>
            <TextContent>Part not found in source, please confirm serial.</TextContent>
          </div>

          <Button
            onClick={(): void => {
              item.confirmFunction(item.serialId);
            }}
            variant="link"
          >
            Confirm and move
          </Button>
        </SpaceBetween>
      );
    }
    return <TextContent>{item.action}</TextContent>;
  },
  sortingField: 'action',
};

export const PART_SCAN_COLUMNS = [
  LOADING_COLUMN,
  SERIAL_COLUMN,
  LOCATION_COLUMN,
  ACTION_REQUIRED_COLUMN,
];
